import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { FeaturedCategoriesAPI } from '../api/featuredcategories/featuredcategoriesapi';
import { FeaturedCategoriesRequest } from '../api/featuredcategories/featuredcategoriesrequest';
import { FeaturedCategoriesResponse } from '../api/featuredcategories/featuredcategoriesresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { FeaturedCategoriesAPIProcessorImpl } from '../processor/featuredcategoriesapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class FeaturedCategoriesProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(FeaturedCategoriesProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getFeaturedCategories():APIProcessor<FeaturedCategoriesRequest, FeaturedCategoriesResponse>
    {
        this.logger.log("getFeaturedCategories() invoked");
        return new FeaturedCategoriesAPIProcessorImpl(this.getContext(), new FeaturedCategoriesAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/featuredcategoriesprocessorfactory.tsx